import React from 'react';
import { branch, compose, withProps } from 'recompose';
import config from '../../config';
import { isMuslimProStore } from '../Common/Store/Store';

const { s3BucketUrl } = config;
const mockCells = [{
  img: `${s3BucketUrl}/home/bestsellers-puzzle.jpg`,
  caption: {id: "landing_page.data_bestseller_puzzle", defaultMsg: "Photo Puzzles"},
  url: '/photo-gifts/photo-puzzles',
  key: 1
}, {
  img: `${s3BucketUrl}/home/bestsellers-photobook.jpg`,
  caption: {id: "landing_page.data_bestseller_photobook", defaultMsg: "Premium Layflat Photo Books"},
  url: '/photobooks',
  key: 2
}, {
  img: `${s3BucketUrl}/home/bestsellers-print.jpg`,
  caption: {id: "landing_page.data_bestseller_print", defaultMsg: "Photo Prints"},
  url: '/prints/photo-prints',
  key: 3
}, {
  img: `${s3BucketUrl}/home/bestsellers-greetingcard.jpg`,
  caption: {id: "landing_page.data_bestseller_greetingcard", defaultMsg: "Greeting Cards"},
  url: '/invitationcards',
  key: 4
}, {
  img: `${s3BucketUrl}/home/bestsellers-canvas.jpg`,
  caption: {id: "landing_page.data_bestseller_canvas", defaultMsg: "Canvas Prints"},
  url: '/home-decor/canvas-prints',
  key: 5
}, {
  img: `${s3BucketUrl}/home/bestsellers-baby.jpg`,
  caption: {id: "landing_page.data_bestseller_baby", defaultMsg: "Gifts For Babies & Kids"},
  url: '/baby-kids',
  key: 6
}];

const mockMuslimProCells = [
  {
    img: `${s3BucketUrl}/home/What+You+Can+Create/muslim_pro/img_imagewrap_hardcover.jpg`,
    caption: {
      id: 'landing_page.data_mp_product_1',
      defaultMsg: 'Imagewrap Photobook',
    },
    url: '/mpro/photobooks/photobook',
    key: 1,
  },
  {
    img: `${s3BucketUrl}/home/What+You+Can+Create/muslim_pro/img_debossed_hardcover.jpg`,
    caption: {
      id: 'landing_page.data_mp_product_2',
      defaultMsg: 'Debossed Photobook',
    },
    url: '/mpro/photobooks/photobook',
    key: 2,
  },
  {
    img: `${s3BucketUrl}/home/What+You+Can+Create/muslim_pro/img_deluxe_hardcover.jpg`,
    caption: {
      id: 'landing_page.data_mp_product_3',
      defaultMsg: 'Deluxe Photobook',
    },
    url: '/mpro/photobooks/photobook',
    key: 3,
  },
  {
    img: `${s3BucketUrl}/home/What+You+Can+Create/muslim_pro/img_canvas_print.jpg`,
    caption: {
      id: 'landing_page.data_mp_product_4',
      defaultMsg: 'Canvas Prints',
    },
    url: '/mpro/canvas-prints',
    key: 4,
  },
  {
    img: `${s3BucketUrl}/home/What+You+Can+Create/muslim_pro/img_canvas_tote_bags.jpg`,
    caption: {
      id: 'landing_page.data_mp_product_5',
      defaultMsg: 'Canvas Tote Bags',
    },
    url: '/mpro/canvas-tote-bags',
    key: 5,
  },
  {
    img: `${s3BucketUrl}/home/What+You+Can+Create/muslim_pro/img_desk_calendar.jpg`,
    caption: {
      id: 'landing_page.data_mp_product_6',
      defaultMsg: 'Desk Calendars',
    },
    url: '/mpro/desk-calendars',
    key: 6,
  },
];

export const withLandingPageData = compose(
  branch(
    ({ store: { code = '' } }) => code.length < 1,
    withProps({ cells: [] }),
    branch(
      ({ store }) => !isMuslimProStore(store),
      withProps({ cells: mockCells }),
      withProps({ cells: mockMuslimProCells }),
    ),
  ),
);



// WEBPACK FOOTER //
// ./src/LandingPage/Data.js